import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { AdplatformTrainingRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/adplatform-training`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);

  return remoteProps => <AdplatformTrainingRemote router={router} store={store} {...remoteProps} />;
});
